import { customScroll } from "@/styles/globalStyles";
import styled from "styled-components";

export const MainWrapper = styled.div`
  padding: 20px;
  @media only screen and (max-width: 1200px) {
    padding: 0;
  }
`;

export const GamesButton = styled.button`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;

  background-color: ${(props) => props.theme.secondary}1a;
  padding: 4px 8px;
  border: unset;
  border-radius: 5px;
  color: ${(props) => props.theme.secondary};
  margin-top: 10px;
`;

export const GptWrapper = styled.div`
  display: flex;
  flex-direction: column;
  position: fixed;
  width: 100%;
  bottom: 0;
  top: 60px;
  margin: 0;
  overflow: auto;

  @media (min-width: 1200px) {
    position: relative;
    width: unset;
    margin: 0 25px;
    top: 0;
    height: 100%;
  }
`;

export const GptHeader = styled.div`
  position: sticky;
  top: 0;
  display: flex;
  justify-content: space-between;
  align-items: center;
  text-align: center;
  padding: 25px;
  border-top-left-radius: 5px;
  border-top-right-radius: 5px;
  background-color: ${(props) => props.theme.backgroundColor};

  div {
    display: flex;
    align-items: center;
    background-color: ${(props) => props.theme.backgroundColor} !important;
  }

  button {
    background-color: ${(props) => props.theme.bottomColor};
    border: 2px solid ${(props) => props.theme.inputColor};
    padding: 5px 8px;
    border-radius: 5px;
    margin: 0 10px;
    &:hover {
      background-color: ${(props) => props.theme.fontColor}10;
    }
  }
  
  button:disabled {
    background-color: ${(props) => props.theme.fontColor}10;
    color: ${props => props.theme.fontColor}32;
    cursor: not-allowed;
  }
`;

export const GptContainer = styled.div`
  overflow: auto;
  @media (min-width: 1200px) {
    ${customScroll}
  }
  height: 100%;

  width: 100%;
  position: absolute;
  scrollbar-width: auto;
  scrollbar-color: #404040 #ffffff;
`;

export const GptChat = styled.div`
  align-items: center;
  gap: 10px;
  padding: 25px 40px;
`;

export const GptTryingFound = styled.div`
  width: 100%;
  height: 74%;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  p {
    margin-top: 10px;
  }
`;

export const GptChatImg = styled.div`
  background-color: ${(props) => props.theme.bottomColor} !important;
  padding: 9px 5px;
  border-radius: 5px;
  img {
    width: 30px;
  }
`;

export const InputChatContainer = styled.div`
  width: 100%;
  position: fixed;
  bottom: 0px;

  input ~ div {
    position: absolute;
    top: 0;
    bottom: 0;
    right: 15px;
    display: flex;
    align-items: center;
    button {
      border: none;
      background-color: ${(props) => props.theme.primary};
      display: flex;
      padding: 10px;
      border-radius: 5px;
    }
    button:disabled {
      background-color: ${(props) => props.theme.primary}32;
      cursor: not-allowed;
      svg {
        color: ${(props) => props.theme.primaryFont}32;
      }
    }
  }

  @media (min-width: 1200px) {
    position: absolute;
    width: calc(100% - 12px);
  }
`;

export const GptChatBox = styled.input`
  width: 100%;
  border-bottom-left-radius: 5px;
  border-bottom-right-radius: 5px;
  border: unset;
  background-color: ${(props) => props.theme.selectColor};
  padding: 25px 40px;
  border-top: 1px solid rgba(255, 255, 255, 0.5);

  &:disabled {
    background-color: ${(props) => props.theme.bottomColor};
    cursor: not-allowed;
  }
`;

export const MessagesBox = styled.div`
  display: flex;
  align-items: center;
  gap: 20px;
  padding: 18px;
  font-size: 1.1rem;
  animation: fadeIn 0.5s;
  transition: ease 500ms;
  a {
    color: ${(props) => props.theme.primary};
    text-decoration: none;
    padding-bottom: 20px;
    padding-top: 20px;
    font-weight: 500;
  }

  p {
    margin-top: 16px;
    margin-bottom: 16px;
    word-break: break-word;
  }

  @keyframes fadeIn {
    0% {
      opacity: 0;
    }

    100% {
      opacity: 1;
    }
  }
`;

export const ImgContMsg = styled.div`
  background-color: unset !important;
  img {
    width: 50px;
  }
`;

export const WideBox = styled.div`
  width: 100%;
  height: 74%;
  position: absolute;
  z-index: -1;
`;

export const MessageWrapper = styled.div`
  padding-bottom: 70px;
  div:nth-child(even) {
    background-color: ${(props) => props.theme.backgroundColor};
  }
  div:nth-child(odd) {
    background-color: ${(props) => props.theme.bottomColor};
  }
`;


export const ModalContainer = styled.div`
  position: absolute;
  inset: 0px;
  display: flex;
  align-items: center;
  justify-content: center;
`;

export const ModalContent = styled.div`
  display: flex;
  flex-direction: column;
  padding: 20px;
  background-color: ${props => props.theme.backgroundColor};
  border-radius: 10px;
  h2 {
    display: flex;
    justify-content: space-between;
    margin-bottom: 32px;

    span {
      cursor: pointer;
      user-select: none;
      padding: 0px 10px;
    }
  }
  p {
    margin: 8px 0;
  }
`;